import t from"react";import{createGlobalStyle as i}from"styled-components";var a=`'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";`,e=i`
  body {
    font-family: ${a};
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }
`;import{createGlobalStyle as n}from"styled-components";var o=n`
  /*
    @reach/ui ignore warning for style not imported, we provide our own style
    see: https://reacttraining.com/reach-ui/styling/
   */

  :root {
    /* stylelint-disable-next-line custom-property-pattern */
    --reach-dialog: 1;
  }
`;import{createGlobalStyle as l}from"styled-components";var r=l`
   /* Box sizing rules */
    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    /* Remove default padding */
    ul,
    ol {
        padding: 0;
    }

    /* Remove default margin */
    body,
    h1,
    h2,
    h3,
    h4,
    p,
    ul,
    ol,
    figure,
    blockquote,
    dl,
    dd {
        margin: 0;
    }

    /* Set core root defaults */
    html {
        scroll-behavior: smooth;
    }

    /* Set core body defaults */
    body {
        min-height: 100vh;
        text-rendering: optimizeSpeed;
        line-height: 1.5;
    }

    /* Remove list styles on ul, ol elements with a class attribute */
    ul,
    ol {
        list-style: none;
    }

    /* A elements that don't have a class get default styles */
    a:not([class]) {
        text-decoration-skip-ink: auto;
    }

    a {
        text-decoration: none;
    }

    /* Make images easier to work with */
    img,
    picture {
        max-width: 100%;
        display: block;
    }

    /* Natural flow and rhythm in articles by default */
    article > * + * {
        margin-top: 1em;
    }

    /* Inherit fonts for inputs and buttons */
    input,
    button,
    textarea,
    select {
        font: inherit;
    }

    /* Blur images when they have no alt attribute */
    img:not([alt]) {
        filter: blur(10px);
    }

    /* Remove all animations and transitions for people that prefer not to see them */
    @media (prefers-reduced-motion: reduce) {
        * {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
            scroll-behavior: auto !important;
        }
    }
`;var y=()=>t.createElement(t.Fragment,null,t.createElement(r,null),t.createElement(o,null),t.createElement(e,null));export{e as Fonts,y as GlobalStyle,o as ReachUI,r as Reset,a as fontDefault};
//# sourceMappingURL=index.js.map